import { render } from "./userAppen.vue?vue&type=template&id=503bf772&scoped=true"
import script from "./userAppen.vue?vue&type=script&lang=js"
export * from "./userAppen.vue?vue&type=script&lang=js"

import "./userAppen.vue?vue&type=style&index=0&id=503bf772&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-503bf772"]])

export default __exports__